module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-quotes page",
    attrs: {
      "id": "page-quotes"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, [(!_vm.showQuotes) ? _c('div', [_c('h1', [_vm._v("Ervaringen van docenten")]), _vm._v(" "), _c('p', [_vm._v("Je hebt hierboven nog niet aangegeven wat je huidige situatie is en hoe je hybride zou willen werken.\n                            Zodra je dit hebt gedaan kun je op deze pagina over ervaringen lezen van hybride docenten die in een vergelijkbare situatie werken.")])]) : _c('div', [_c('h1', [_vm._v("HIERONDER LEES JE HOE HYBRIDE DOCENTEN DIE VOOR EEN VERGELIJKBARE CONSTRUCTIE ALS DIE VAN JOU HEBBEN GEKOZEN HUN HYBRIDE WERK ERVAREN.")]), _vm._v(" "), _c('div', {
    staticClass: "page-quotes__categories"
  }, _vm._l((_vm.quoteCategories), function(category) {
    return _c('div', {
      staticClass: "page-quotes__categories-item",
      class: {
        'page-quotes__categories-item--active': category === _vm.currentCategory
      },
      on: {
        "click": function($event) {
          _vm.selectCategory(category)
        }
      }
    }, [_vm._v(_vm._s(category))])
  })), _vm._v(" "), _c('div', [_c('paged-quotes', {
    attrs: {
      "quotes": _vm.currentQuotes
    }
  })], 1)])])])]), _vm._v(" "), _c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51238f9d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-quotes.vue
// module id = 144
// module chunks = 0